module.exports = "/images/tag_b84aa1.png";